import Nav from "@/components/aix/Nav";
import Hero from "@/components/aix/Hero";
import { Marquee, Pillars, Meetups } from "@/components/aix/Sections";
import BlogRotator from "@/components/aix/BlogRotator";
import { Roadmap, FoundersTeaser, Footer } from "@/components/aix/Sections2";

export default function Home() {
  return (
    <div
      className="bg-white text-slate-900 min-h-screen selection:bg-aix-cyan selection:text-black antialiased"
      data-testid="home-page"
    >
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Pillars />
        <Meetups />
        <Roadmap />
        <FoundersTeaser />
        <BlogRotator />
      </main>
      <Footer />
    </div>
  );
}
